const state = {
  tournament: {},
  tournaments: [],
  tournamentFront: {},
  tournamentCategories: []
}

const getters = {
  tournamentCategories (state) {
    return state.tournamentCategories
  },
  tournament (state) {
    return state.tournament
  },
  tournaments (state) {
    return state.tournaments
  },
  tournamentFront(state) {
    return state.tournamentFront
  }
}

const mutations = {
  SET_TOURNAMENT_CATEGORIES_ADD (state, payload) {
    state.tournamentCategories.unshift(payload)
  },
  SET_TOURNAMENT_CATEGORIES_EDIT (state, payload) {
    state.tournamentCategories = state.tournamentCategories.map(cat => {
      if (cat.id === payload.id) {
        cat.name = payload.name
        cat.order = payload.order
      }
      return cat
    })
  },
  SET_TOURNAMENT_CATEGORIES_DELETE (state, payload) {
    state.tournamentCategories = state.tournamentCategories.filter(cat => {
      return cat.id !== payload.id
    })
  },
  SET_TOURNAMENT_CATEGORIES (state, payload) {
    state.tournamentCategories = payload
  },
  SET_TOURNAMENT (state, payload) {
    state.tournament = payload
  },
  SET_TOURNAMENT_IMAGE (state, payload) {
    state.tournaments = state.tournaments.map(tournament => {
      if (tournament.id === payload.id) {
        tournament.image = payload.image
      }
      return tournament
    })
  },
  SET_TOURNAMENT_MONEY (state, payload) {
    state.tournaments = state.tournaments.map(tournament => {
      if (tournament.id === payload.tournament_id) {
        if (payload.option === 'add') {
          tournament.quantity = parseInt(tournament.quantity) + parseInt(payload.quantity)
        } else {
          tournament.quantity = parseInt(tournament.quantity) - parseInt(payload.quantity)
        }
      }
      return tournament
    })
  },
  SET_TOURNAMENT_SIGNINGS (state, payload) {
    state.tournaments = state.tournaments.map(tournament => {
      if (tournament.id === payload.id) {
        tournament.lock_signing = payload.status
      }
      return tournament
    })
  },
  SET_TOURNAMENTS (state, payload) {
    state.tournaments = payload
  },
  DELETE_TOURNAMENT (state, payload) {
    state.tournaments = state.tournaments.filter((tournament) => {
      return tournament.id !== payload.id
    })
  },
  ADD_TOURNAMENT (state, payload) {
    state.tournaments.push(payload)
  },
  SET_TOURNAMENT_FRONT (state, payload) {
    state.tournamentFront = payload
  }
}

const actions = {
  SET_TOURNAMENT_SIGNINGS(context, payload) {
    context.commit('SET_TOURNAMENT_SIGNINGS', payload)
  },
  SET_TOURNAMENT_CATEGORIES_ADD(context, payload) {
    context.commit('SET_TOURNAMENT_CATEGORIES_ADD', payload)
  },
  SET_TOURNAMENT_CATEGORIES_EDIT(context, payload) {
    context.commit('SET_TOURNAMENT_CATEGORIES_EDIT', payload)
  },
  SET_TOURNAMENT_CATEGORIES_DELETE(context, payload) {
    context.commit('SET_TOURNAMENT_CATEGORIES_DELETE', payload)
  },
  SET_TOURNAMENT_CATEGORIES(context, payload) {
    context.commit('SET_TOURNAMENT_CATEGORIES', payload)
  },
  SET_TOURNAMENT_IMAGE(context, payload) {
    context.commit('SET_TOURNAMENT_IMAGE', payload)
  },
  DELETE_TOURNAMENT (context, payload) {
    context.commit('DELETE_TOURNAMENT', payload)
  },
  ADD_TOURNAMENT (context, payload) {
    context.commit('ADD_TOURNAMENT', payload)
  },
  SET_TOURNAMENT (context, payload) {
    context.commit('SET_TOURNAMENT', payload)
  },
  SET_TOURNAMENTS (context, payload) {
    context.commit('SET_TOURNAMENTS', payload)
  },
  SET_TOURNAMENT_FRONT(context, payload) {
    context.commit('SET_TOURNAMENT_FRONT', payload)
  },
  SET_TOURNAMENT_MONEY(context, payload) {
    context.commit('SET_TOURNAMENT_MONEY', payload)
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
